export const defaultGermanThousandSeparator = ".";
export const defaultGermanDecimalSeparator = ",";